export default "__VITE_ASSET__CcKz7GN7__"